<script>
	import {get} from "svelte/store";
	import Papa from "papaparse";
	import ModalWindow from "../ModalWindow.svelte";
	import "./CustomGeoJSONOverlayForm.scss";

	import Radio from "@smui/radio";
	import FormField from '@smui/form-field';

	import Form from '../Admin/Form.svelte';

	import Button, {Label} from '@smui/button';
	import DataTable, {Head, Body, Row, Cell} from '@smui/data-table';
	import {HsvPicker} from 'svelte-color-picker';

	import MapControlType from "../../Map/Enums/MapControlType";
	import MapStore from "../../Map/Store";
	import MapLayerManager from "../../Map/MapLayerManager";

	import GeoHelper from "../../Helpers/GeoHelper";
	import ColorHelper from "../../Helpers/ColorHelper";

	import PropertyList from "../PropertyList/PropertyList"
	import PropertyListComponent from "../PropertyList/PropertyListComponent.svelte"

	import EditCustomGeoJSONStore from "./EditStore";
	import ShapeType from "./ShapeType";

	let index = EditCustomGeoJSONStore.shape.index;
	let shapeType = EditCustomGeoJSONStore.shape.type;
	let properties = EditCustomGeoJSONStore.shape.properties;
	let colorHex = EditCustomGeoJSONStore.shape.color;
	let colorRGBA = EditCustomGeoJSONStore.shape.colorRGBA;

	let visible = EditCustomGeoJSONStore.meta.visible;
	let lastUpdated = EditCustomGeoJSONStore.meta.lastUpdated;

	let control = MapStore.control;

	let error = false;
	let errorMessage = "";

	let hsvPicker = null;
	let color = [0,0,0,1];
	let colorRGBAString = "rgba(0, 0, 0, 1.0)";
	let colorPickVisible = false;
	let propertyList = new PropertyList();
	let toggleColorPickerVisibility = () => {
		colorPickVisible = !colorPickVisible;
	};
	$: {
		$visible;
		if ($visible) {
			propertyList.reset($properties);
		}
	}
	$: {
		$visible;
		$lastUpdated;

		let thisColor = $colorRGBA;
		color[0] = thisColor[0]/255.0;
		color[1] = thisColor[1]/255.0;
		color[2] = thisColor[2]/255.0;
		color[3] = thisColor[3];
		colorRGBAString = `rgba(${$colorRGBA[0]}, ${$colorRGBA[1]}, ${$colorRGBA[2]}, ${$colorRGBA[3]})`;
		color = color;
		// console.log("hsvPicker", hsvPicker);
	}
	$: {
		propertyList.reset($properties);
		propertyList = propertyList;
	}

	let style = "width:100%;margin-top:5px;";
	let errorStyle = "width:calc(100% - 20px);margin-top:10px;padding:10px;border-radius:3px;";

	let resetError = () => {
		error = false;
		errorMessage = "";
	};
	let onClose = () => {
		$control = MapControlType.PAN;
		resetError();
	};
	let onSubmit = () => {
		let thisProperties = propertyList.data;
		console.log("thisProperties", thisProperties);
		console.log("colorHex", $colorHex);
		console.log("index", $index);
		console.log("shapeType", $shapeType);

		if ($shapeType === ShapeType.POLYGON || $shapeType === ShapeType.LINE) {
			const currentLayers = get(MapStore.controlData.customGeojson.layers.input);
			let featureCollection = currentLayers[$index];
			featureCollection.features[0].properties = thisProperties;
			featureCollection.features[0].properties.color = colorRGBAString; // $colorHex
			featureCollection.features[0].properties.index = $index;
			MapStore.controlData.customGeojson.layers.input.set(currentLayers);

			$visible = false;
		}
		else { // Point/marker
			// MapStore.controlData.draw.markers.set(currentMarkers);
			let currentMarkers = get(MapStore.controlData.draw.markers);
			let thisMarker = currentMarkers[$index];
			thisMarker.properties = thisProperties;
			thisMarker.properties.color = colorRGBAString; // $colorHex;
			thisMarker.properties.index = $index;
			MapStore.controlData.draw.markers.set(currentMarkers);
			MapLayerManager.updateCustomMarkers();

			$visible = false;
		}
	};

</script>

<ModalWindow title={`Edit Custom Geometry`} resizable={true} draggable={true} fullscreen={false} padding={true} hasCloseButton={true} hasBackground={false} on:close={onClose} bind:open={$visible}>

	<p style="display:none">{$lastUpdated}</p>
	<Form id='edit-custom-geometry-form'>
		<DataTable table$aria-label="User" style={style}>
			<Head style="display: none">
				<Row>
					<Cell></Cell>
					<Cell></Cell>
				</Row>
			</Head>
			<Body>
				<Row>
					<Cell>Shape:</Cell>
					<Cell>{$shapeType}</Cell>
				</Row>
				<Row>
					<Cell>Color:</Cell>
					<Cell>
						<div class='p-5'>
							<div class='color-sq' style="background-color: rgba({color[0]*255}, {color[1]*255},{color[2]*255}, {color[3]});"
										on:click={toggleColorPickerVisibility}>
							</div>
							(<a href="/" on:click|preventDefault={toggleColorPickerVisibility}>{#if !colorPickVisible}edit{:else}close{/if}</a>)
						</div>
						{#if colorPickVisible}
							<div class='p-5'>
								<HsvPicker bind:this={hsvPicker} on:colorChange={(rgba) => {
									console.log(rgba);
									color[0] = rgba.detail.r/255.0;
									color[1] = rgba.detail.g/255.0;
									color[2] = rgba.detail.b/255.0;
									color[3] = rgba.detail.a;
									$colorHex = ColorHelper.rgbToHex(rgba.detail.r, rgba.detail.g, rgba.detail.b);
									$colorRGBA = [
										rgba.detail.r,
										rgba.detail.g,
										rgba.detail.b,
										rgba.detail.a
									];
									console.log($colorHex);
								}} startColor={$colorHex}/>
							</div>
						{/if}
					</Cell>
				</Row>
				<Row>
					<Cell>Properties:</Cell>
					<Cell>
						<PropertyListComponent name="image" propertyList={propertyList} width={"50%"} style={"margin:10px;"} on:update={()=>{}}/>
					</Cell>
				</Row>

			</Body>
		</DataTable>

		{#if error && errorMessage.length > 0}
			<div class="bg-error" style={errorStyle}>{@html errorMessage}</div>
		{/if}

		<Button color="primary" variant="unelevated" style={style} on:click={onSubmit}>
			<Label>Save</Label>
		</Button>
	</Form>

</ModalWindow>
